import type { Dayjs } from 'dayjs';

import type { ActivityDTO } from 'src/types/dto/activity.dto';
import type { AppointmentDTO } from 'src/types/dto/appointment.dto';

import dayjs from 'dayjs';

import { getNonBlockerAppointments } from 'src/components/inspector-reschedule-card/utils';

export const getCurrentNonBlockerAppointmentDates = (
  currentActivity: ActivityDTO,
  appointment?: AppointmentDTO
): Dayjs[] => {
  const appointments = getNonBlockerAppointments(
    currentActivity.appointments?.length ? currentActivity.appointments : appointment ? [appointment] : []
  );

  const uniqueDates = new Map<string, Dayjs>();

  appointments.forEach((item) => {
    const date = dayjs(item.from).startOf('day');
    if (date.isValid()) {
      uniqueDates.set(date.format('YYYY-MM-DD'), date);
    }
  });

  return Array.from(uniqueDates.values()).sort((left, right) => left.valueOf() - right.valueOf());
};
